import { endpoints } from "../config";
import { getData, postData, putData, deleteData } from "./api-utils";

const routeURL = endpoints.theme;
const addUrl = endpoints.themeToQuestion;

const getTheme = async () => {
  return await getData(routeURL);
};
const postTheme = async (data) => {
  return await postData(routeURL, data);
};
const updateTheme = async (data, itemId) => {
  return await putData(`${routeURL}/${itemId}`, data);
};
const deleteTheme = async (itemId) => {
  return await deleteData(`${routeURL}/${itemId}`);
};

const getThemeToQuestion = async (questionId) => {
  return await getData(`${addUrl}/${questionId}`);
};
const postThemeToQuestion = async (questionId, themeId) => {
  return await postData(`${addUrl}`, { questionId, themeId });
};
const deleteThemeToQuestion = async (realationId) => {
  return await deleteData(`${addUrl}/${realationId}`);
};

export {
  getTheme,
  postTheme,
  updateTheme,
  deleteTheme,
  getThemeToQuestion,
  postThemeToQuestion,
  deleteThemeToQuestion,
};
